import { render, staticRenderFns } from "./ModifyInfo.vue?vue&type=template&id=05ae9bdc"
import script from "./ModifyInfo.vue?vue&type=script&lang=js"
export * from "./ModifyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports